var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1425.979,
    height: 375.514,
    viewBox: "0 0 1425.979 375.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7388",
    "data-name": "Path 7388",
    d: "M11057,2034.835s65.771-313.532,248.9-230.961,294.786,203.357,518.773,162.8,421.07-238.255,542.985-54.891,112.945,251.6,112.945,251.6",
    transform: "translate(-11055.816 -1788.984)",
    fill: "none",
    stroke: "#b4b4b4",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLine);
export default __webpack_public_path__ + "static/media/dash-line.e8972232fbc51c6a404a1bce7ff170b1.svg";
export { ForwardRef as ReactComponent };